module.exports = __webpack_public_path__ + "static/img/icon_mayor.6ebda4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_mayor.png
// module id = rVlr
// module chunks = 11